import { UNMATCHED_FILE_GROUP_BY } from './constants';

// Logic around the leading chip which calls useFilterParams differently

const SIGNER = 'signer';
const APP = 'app';

const SIGNER_LABELS = {
  [UNMATCHED_FILE_GROUP_BY.PublisherName]: 'Publisher',
  [UNMATCHED_FILE_GROUP_BY.IssuerTbsHash]: 'Issuer TBS',
};
const DEFAULT_SIGNER_LABEL = 'Publisher TBS';

export const NO_GROUP = { groupKind: '', groupKey: '', groupValue: '' };

export const signerGroup = groupKey => ({
  groupKind: SIGNER,
  groupKey: groupKey ?? '',
  groupValue: '',
});

export const appGroup = (globalApplicationVersionId, appName) => ({
  groupKind: APP,
  groupKey: String(globalApplicationVersionId ?? ''),
  groupValue: appName ?? '',
});

export const groupFilterFrom = (group, groupBy) => {
  if (!group?.groupKey) {
    return null;
  }

  const isApp = group.groupKind === APP;
  const groupLabel = isApp ? 'App' : SIGNER_LABELS[groupBy] ?? DEFAULT_SIGNER_LABEL;
  const groupValue = (isApp ? group.groupValue : group.groupKey) || '—';

  return {
    kind: group.groupKind,
    groupLabel,
    groupValue,
    label: `${groupLabel}: ${groupValue}`,
    params: isApp
      ? { globalApplicationVersionId: Number(group.groupKey) }
      : { groupBy, groupKey: group.groupKey },
  };
};
